<style scoped>
.r-custom tr td {
    width: 14.28571%;
}
</style>
<template>

    <div class="">
        <b-overlay :show="showoverlay" rounded="sm" class="col-md-12">
            <div class="clearfix row py-2 mb-2 no-margin">
                <div class="col-md-12 no-margin p-0">
                    <div class="row d-flex justify-content-end no-margin">
                        <b-button variant="secondary" class="d-flex justify-content-end m-1 btn-warning"
                            @click="previewOrDownload(0)">Preview Report</b-button>
                        <b-button variant="secondary" class="d-flex justify-content-end m-1 btn-warning"
                            @click="resetView()">Reset Selection</b-button>
                        <b-button variant="secondary" class="d-flex justify-content-end m-1 btn-warning"
                            @click="previewOrDownload(1)">Download Report (Excel)</b-button>
                    </div>
                </div>
            </div>

            <div v-if="this.is_grid_diplayable">
                <common-list-leave-report ref="leaveReport" :checkbox="checkbox" :appended_column="appended_column" :key="list_key"
                    :company_options="company_options" :employees="custom_list" :default_column="default_column"
                    :primary_key="primary_key" v-on:childToParent="listReturn"></common-list-leave-report>

            </div>


            <div class="card p-3" v-if="!this.is_grid_diplayable && this.is_preview">
                <h4>Long Service Leave Report</h4>
                <div class="card-body container px-0 ">
                    <div class="row justify-content-center no-margin">
                        <div class="col-sm-12 px-0">
                            <b-overlay :show="showoverlay_list" rounded="sm">
                                <table class="table dataTable border">
                                    <thead>
                                        <tr class="table-head">
                                            <th v-for="col in previewColumns" :key="'head_' + col.key">{{ col.title }}</th>
                                            <th>Service Length<br>(Months)</th>
                                            <th>Allow Tier<br>(Months)</th>
                                            <th>Allowed Leaves</th>
                                            <th>Consumed Leaves</th>
                                            <th>Remaining Leaves</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in preview_data" :key="index">
                                            <td v-for="col in previewColumns" :key="'data_' + col.key">{{ getColValue(item, col.key) }}</td>
                                            <td>{{ item.service_months }}</td>
                                            <td>{{ item.minimum_required_months }}</td>
                                            <td>{{ item.leaves_entitled }}</td>
                                            <td>{{ item.leaves_enjoyed }}</td>
                                            <td>{{ item.leaves_remaining }}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div v-if="preview_data.length === 0" class="list-no-data">No records found.</div>
                            </b-overlay>
                        </div>
                    </div>
                </div>
            </div>
        </b-overlay>
    </div>
</template>


<script>
export default {

    mounted() {

    },
    props: [],
    data() {
        const now = new Date()
        return {
            /**Child Component property data */
            selected: [],
            checkbox: 1,
            list_key: 0, /* Component Key */
            custom_list: [],  /* Data List */
            default_column: ['name', 'phone', 'email', 'jobposition', 'department', 'branch'],
            appended_column: [],
            primary_key: 'employee_id',
            company_options: [],
            tmp_custom_list: [],
            employee_ids: [],
            preview_data: [],
            is_preview: 0,
            is_grid_diplayable: 1,
            showoverlay: false,
            cached_enabled_fields: [],
        }
    },
    methods: {
        getColValue(item, key) {
            if (key === 'designation' || key === 'jobposition') {
                return item.designation || item.jobposition || '-';
            }
            return item[key] || '-';
        },
        resetView: function () {
            this.is_grid_diplayable = 1;
            this.preview_data = '';
            this.selected = '';
            this.list_key += 1;

        },
        listReturn: function (data) {
            this.selected = data;
        },

        getEmployeesList: function () {

            if (!this.checkNet()) return false;
            let currentObj = this;
            this.showoverlay = true;
            axios.get(this.$api_url + '/longservice-leave/get-all-employees', {

            }).then(function (response) {

                /* Assingning the list */
                this.tmp_custom_list = response.data.employee_data;
                this.company_options = response.data.options;

                this.custom_list = this.tmp_custom_list;
                this.showoverlay = false;

                this.list_key = this.list_key + 1;
            }.bind(this)).catch(function (error) { currentObj.serverError(error); });

        },
        previewOrDownload: function (flg) {
            if (!this.checkNet()) return false;

            if (typeof this.selected.selected == 'undefined')
                this.$bvToast.toast("Please select employee(s) to generate report", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
            else if (this.selected.selected == '')
                this.$bvToast.toast("Please select employee(s) to generate report", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });

            else {
                let enabledFields = [];
                if (this.$refs.leaveReport) {
                    const defaultFields = this.$refs.leaveReport.default_column || [];
                    const appendedFields = (this.$refs.leaveReport.appended_column || []).map(col => col.value || col);
                    const selectedFields = this.$refs.leaveReport.column_selected || [];
                    enabledFields = [...defaultFields, ...appendedFields, ...selectedFields];
                    this.cached_enabled_fields = enabledFields;
                } else {
                    enabledFields = this.cached_enabled_fields || [];
                }
                enabledFields = enabledFields.filter(field => field !== 'leave_type');

                let currentObj = this;
                if (flg == 0) {
                    this.$bvToast.toast('We are generating the report, this may take a while, please hold tight.', {
                        title: `Info`,
                        variant: 'info',
                        solid: true
                    });
                }
                else if (flg == 1) {
                    this.$bvToast.toast('We are downloading the report, this may take a while, please hold tight.', {
                        title: `Info`,
                        variant: 'info',
                        solid: true
                    });
                }

                this.showoverlay = true;

                axios.post(this.$api_url + '/longservice-leave/get-long-service-leave-list', {
                    employee_ids: JSON.stringify(this.selected.selected),
                    is_export: flg,
                    enabled_fields: JSON.stringify(enabledFields),
                }, {
                    responseType: flg === 1 ? 'blob' : 'json'
                })
                    .then(function (response) {
                        this.showoverlay = false;

                        if (flg === 0) {
                            this.preview_data = response.data;
                            console.log(response.data);
                            this.is_preview = 1;
                            this.is_grid_diplayable = 0;
                        } else if (flg === 1) {
                            // Handle file download
                            const blob = new Blob([response.data], { type: response.headers['content-type'] });
                            const fileName = response.headers['content-disposition']
                                ? response.headers['content-disposition'].split('filename=')[1].replace(/"/g, '')
                                : 'download.xlsx';

                            const link = document.createElement('a');
                            link.href = URL.createObjectURL(blob);
                            link.setAttribute('download', fileName);
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                            URL.revokeObjectURL(link.href);
                        }
                    }.bind(this))
                    .catch(function (error) {
                        this.showoverlay = false;
                        currentObj.serverError(error);
                    }.bind(this));
            }
        },
    },
    created: function () {
        this.getEmployeesList();
    },
    computed: {
        previewColumns() {
            const titleMap = {
                'employee_code': 'Employee Code',
                'name': 'Employee Name',
                'jobposition': 'Designation',
                'designation': 'Designation',
                'department': 'Department',
                'branch': 'Work Location',
                'phone': 'Mobile Number',
                'email': 'Email',
                'joining_date': 'Joining Date',
            };

            const activeFields = (this.cached_enabled_fields && this.cached_enabled_fields.length > 0)
                ? this.cached_enabled_fields
                : (this.default_column || ['name']);

            const cols = [];
            const seen = new Set();

            activeFields.forEach(field => {
                const code = (field === 'designation' || field === 'jobposition') ? 'jobposition' : field;
                if (!seen.has(code)) {
                    seen.add(code);
                    cols.push({
                        key: code,
                        title: titleMap[field] || titleMap[code] || (field.charAt(0).toUpperCase() + field.slice(1).replace('_', ' '))
                    });
                }
            });

            return cols;
        }
    }
}
</script>
